import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IGhat, IGhatInitialState } from "./ghatModel";
import {
  createGhat,
  deleteGhadiaIssueItems,
  deleteGhat,
  deleteGhatItems,
  findAllGhat,
  getGhatById,
  updateGhat,
} from "./services/ghat.services";

const initialState: IGhatInitialState = {
  loading: false,
  error: "",
  GhatID: null,
  GhatList: [],
  GhatDetail: {
    issue_date: new Date(),
    karigar_id: null,
    approx_delivery_date: "",
    given_amount: null,
    remarks: "",
    ghat_item: [],
    ghat_gold_issues: [],
    isactive: 1,
  },
  GhatOrderItemIndex: -1,
  GhatSelectOrderItemIndex: -1,
  GhatGoldIssueItemIndex: -1,
  GhatApprovalItemIndex: -1,
  GhatOrderSelectionDialog: false,
  GhatApprovalItemDeleteDialog: false,
  GhatViewImageDialog: false,
  GhatOrderSave: false,
  FilterGhat: {
    karigar_name: "",
    karigar_nick_name: "",
    issue_date: "",
    approx_delivery_date: "",
  },
  GhatPreviousOrder: null,
};

const orderSlice = createSlice({
  name: "ghat",
  initialState,
  reducers: {
    clearGhatDetail: (state) => {
      state.GhatDetail = initialState.GhatDetail;
    },
    setGhatID: (state, action) => {
      state.GhatID = action.payload;
    },
    setFilterGhat: (state, action) => {
      state.FilterGhat = action.payload;
    },
    setGhatPreviousOrder: (state, action) => {
      state.GhatPreviousOrder = action.payload;
    },
    clearFilterGhat: (state) => {
      state.FilterGhat = initialState.FilterGhat;
    },
    setGhatOrderSave: (state, action) => {
      state.GhatOrderSave = action.payload;
    },

    setGhatOrderItemIndex: (state, action) => {
      state.GhatOrderItemIndex = action.payload;
    },
    setGhatGoldIssueItemIndex: (state, action) => {
      state.GhatGoldIssueItemIndex = action.payload;
    },
    setGhatApprovalItemIndex: (state, action) => {
      state.GhatApprovalItemIndex = action.payload;
    },
    setGhatSelectOrderItemIndex: (state, action) => {
      state.GhatSelectOrderItemIndex = action.payload;
    },

    openGhatOrderSelectionDialog: (state) => {
      state.GhatOrderSelectionDialog = true;
    },
    closeGhatOrderSelectionDialog: (state) => {
      state.GhatOrderSelectionDialog = false;
    },
    openGhatApprovalItemDeleteDialog: (state) => {
      state.GhatApprovalItemDeleteDialog = true;
    },
    closeGhatApprovalItemDeleteDialog: (state) => {
      state.GhatApprovalItemDeleteDialog = false;
    },
    openGhatViewImageDialog: (state) => {
      state.GhatViewImageDialog = true;
    },
    closeGhatViewImageDialog: (state) => {
      state.GhatViewImageDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllGhat.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllGhat.fulfilled,
      (state, action: PayloadAction<IGhat[]>) => {
        state.loading = false;
        state.GhatList = action.payload || [];
      }
    );
    builder.addCase(findAllGhat.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GhatList = [];
    });

    builder.addCase(createGhat.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createGhat.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createGhat.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateGhat.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateGhat.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateGhat.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteGhat.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteGhat.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGhat.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getGhatById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getGhatById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.GhatDetail = action.payload;
    });
    builder.addCase(getGhatById.rejected, (state, action) => {
      state.loading = false;
      state.GhatDetail = initialState.GhatDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteGhatItems.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(deleteGhatItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGhatItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteGhadiaIssueItems.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(deleteGhadiaIssueItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteGhadiaIssueItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearFilterGhat,
  clearGhatDetail,
  closeGhatApprovalItemDeleteDialog,
  closeGhatOrderSelectionDialog,
  closeGhatViewImageDialog,
  openGhatApprovalItemDeleteDialog,
  openGhatOrderSelectionDialog,
  openGhatViewImageDialog,
  setFilterGhat,
  setGhatApprovalItemIndex,
  setGhatGoldIssueItemIndex,
  setGhatID,
  setGhatOrderItemIndex,
  setGhatSelectOrderItemIndex,
  setGhatOrderSave,
  setGhatPreviousOrder,
} = orderSlice.actions;
export default orderSlice.reducer;
